// DO NOT MODIFY BY HAND!!
// Go through Readme.md

import { ReactComponent as InflationGraph } from './icon-inflationGraph.svg';
import { ReactComponent as InsurancePerson } from './icon-insurancePerson.svg';
import { ReactComponent as SendMessage } from './icon-sendMessage.svg';
import { ReactComponent as ActivityLine } from './activity_line.svg';
import { ReactComponent as AlertTriangleSolid } from './alert-triangle_solid.svg';
import { ReactComponent as AnchorLine } from './anchor_line.svg';
import { ReactComponent as AnnouncementSolid } from './announcement_solid.svg';
import { ReactComponent as ArchiveSolid } from './archive_solid.svg';
import { ReactComponent as ArrowCircleBrokenDownLine } from './arrow-circle-broken-down_line.svg';
import { ReactComponent as ArrowCircleBrokenDownSolid } from './arrow-circle-broken-down_solid.svg';
import { ReactComponent as ArrowCircleBrokenLeftLine } from './arrow-circle-broken-left_line.svg';
import { ReactComponent as ArrowCircleBrokenLeftSolid } from './arrow-circle-broken-left_solid.svg';
import { ReactComponent as ArrowCircleBrokenRightLine } from './arrow-circle-broken-right_line.svg';
import { ReactComponent as ArrowCircleBrokenRightSolid } from './arrow-circle-broken-right_solid.svg';
import { ReactComponent as ArrowCircleBrokenUpLeftLine } from './arrow-circle-broken-up-left_line.svg';
import { ReactComponent as ArrowCircleBrokenUpLeftSolid } from './arrow-circle-broken-up-left_solid.svg';
import { ReactComponent as ArrowCircleBrokenUpRightLine } from './arrow-circle-broken-up-right_line.svg';
import { ReactComponent as ArrowCircleBrokenUpRightSolid } from './arrow-circle-broken-up-right_solid.svg';
import { ReactComponent as ArrowCircleBrokenUpLine } from './arrow-circle-broken-up_line.svg';
import { ReactComponent as ArrowCircleBrokenUpSolid } from './arrow-circle-broken-up_solid.svg';
import { ReactComponent as ArrowCircleDownLeftLine } from './arrow-circle-down-left_line.svg';
import { ReactComponent as ArrowCircleDownLeftSolid } from './arrow-circle-down-left_solid.svg';
import { ReactComponent as ArrowCircleDownRightLine } from './arrow-circle-down-right_line.svg';
import { ReactComponent as ArrowCircleDownRightSolid } from './arrow-circle-down-right_solid.svg';
import { ReactComponent as ArrowCircleDownLine } from './arrow-circle-down_line.svg';
import { ReactComponent as ArrowCircleLeftLine } from './arrow-circle-left_line.svg';
import { ReactComponent as ArrowCircleLeftSolid } from './arrow-circle-left_solid.svg';
import { ReactComponent as ArrowCircleRightLine } from './arrow-circle-right_line.svg';
import { ReactComponent as ArrowCircleRightSolid } from './arrow-circle-right_solid.svg';
import { ReactComponent as ArrowCircleUpLine } from './arrow-circle-up_line.svg';
import { ReactComponent as ArrowNarrowDownLeftLine } from './arrow-narrow-down-left_line.svg';
import { ReactComponent as ArrowNarrowDownRightLine } from './arrow-narrow-down-right_line.svg';
import { ReactComponent as ArrowNarrowRightLine } from './arrow-narrow-right_line.svg';
import { ReactComponent as ArrowNarrowUpLeftLine } from './arrow-narrow-up-left_line.svg';
import { ReactComponent as ArrowNarrowUpRightLine } from './arrow-narrow-up-right_line.svg';
import { ReactComponent as ArrowSquareDownLine } from './arrow-square-down_line.svg';
import { ReactComponent as ArrowSquareDownSolid } from './arrow-square-down_solid.svg';
import { ReactComponent as ArrowSquareLeftLine } from './arrow-square-left_line.svg';
import { ReactComponent as ArrowSquareLeftSolid } from './arrow-square-left_solid.svg';
import { ReactComponent as ArrowSquareRightLine } from './arrow-square-right_line.svg';
import { ReactComponent as ArrowSquareRightSolid } from './arrow-square-right_solid.svg';
import { ReactComponent as ArrowSquareUpLine } from './arrow-square-up_line.svg';
import { ReactComponent as ArrowSquareUpSolid } from './arrow-square-up_solid.svg';
import { ReactComponent as Asterisk01Line } from './asterisk-01_line.svg';
import { ReactComponent as Asterisk02Line } from './asterisk-02_line.svg';
import { ReactComponent as AtSignLine } from './at-sign_line.svg';
import { ReactComponent as BankSolid } from './bank_solid.svg';
import { ReactComponent as BarChartSolid } from './bar-chart_solid.svg';
import { ReactComponent as BookClosedSolid } from './book-closed_solid.svg';
import { ReactComponent as BookmarkAddLine } from './bookmark-add_line.svg';
import { ReactComponent as BookmarkAddSolid } from './bookmark-add_solid.svg';
import { ReactComponent as BookmarkCheckLine } from './bookmark-check_line.svg';
import { ReactComponent as BookmarkCheckSolid } from './bookmark-check_solid.svg';
import { ReactComponent as BookmarkMinusLine } from './bookmark-minus_line.svg';
import { ReactComponent as BookmarkMinusSolid } from './bookmark-minus_solid.svg';
import { ReactComponent as BookmarkXLine } from './bookmark-x_line.svg';
import { ReactComponent as BookmarkXSolid } from './bookmark-x_solid.svg';
import { ReactComponent as BookmarkSolid } from './bookmark_solid.svg';
import { ReactComponent as BriefcaseSolid } from './briefcase_solid.svg';
import { ReactComponent as Building01Line } from './building-01_line.svg';
import { ReactComponent as Building01Solid } from './building-01_solid.svg';
import { ReactComponent as Building02Line } from './building-02_line.svg';
import { ReactComponent as Building02Solid } from './building-02_solid.svg';
import { ReactComponent as CalculatorSolid } from './calculator_solid.svg';
import { ReactComponent as CalendarDateSolid } from './calendar-date_solid.svg';
import { ReactComponent as CameraSolid } from './camera_solid.svg';
import { ReactComponent as ChatCircleSolid } from './chat-circle_solid.svg';
import { ReactComponent as ChevronSelectorVertical } from './chevron-selector-vertical.svg';
import { ReactComponent as CircleChevronDownSolid } from './circle-chevron-down_solid.svg';
import { ReactComponent as CircleChevronLeftSolid } from './circle-chevron-left_solid.svg';
import { ReactComponent as CircleChevronRightSolid } from './circle-chevron-right_solid.svg';
import { ReactComponent as CircleChevronUpSolid } from './circle-chevron-up_solid.svg';
import { ReactComponent as CircleSwitchHorizontal01Solid } from './circle-switch-horizontal-01_solid.svg';
import { ReactComponent as CircleSwitchHorizontal02Solid } from './circle-switch-horizontal-02_solid.svg';
import { ReactComponent as CircleSwitchVertical02Solid } from './circle-switch-vertical-02_solid.svg';
import { ReactComponent as ClockSolid } from './clock_solid.svg';
import { ReactComponent as CoinsHandSolid } from './coins-hand_solid.svg';
import { ReactComponent as CoinsStackedSolid } from './coins-stacked_solid.svg';
import { ReactComponent as CopySolid } from './copy_solid.svg';
import { ReactComponent as DeleteSolid } from './delete_solid.svg';
import { ReactComponent as Edit01Solid } from './edit-01_solid.svg';
import { ReactComponent as EyeOffSolid } from './eye-off_solid.svg';
import { ReactComponent as EyeSolid } from './eye_solid.svg';
import { ReactComponent as FileAttachmentSolid } from './file-attachment_solid.svg';
import { ReactComponent as FileChartSolid } from './file-chart_solid.svg';
import { ReactComponent as FileDownloadSolid } from './file-download_solid.svg';
import { ReactComponent as FileSolid } from './file_solid.svg';
import { ReactComponent as FolderSolid } from './folder_solid.svg';
import { ReactComponent as GiftSolid } from './gift_solid.svg';
import { ReactComponent as GraduationHatSolid } from './graduation-hat_solid.svg';
import { ReactComponent as GridSolid } from './grid_solid.svg';
import { ReactComponent as HelpCircleLine } from './help-circle_line.svg';
import { ReactComponent as HourglassSolid } from './hourglass_solid.svg';
import { ReactComponent as AdvisorFilled } from './icon-advisor-filled.svg';
import { ReactComponent as AdvisorOutline } from './icon-advisor-outline.svg';
import { ReactComponent as AlertOctagon } from './icon-alertOctagon.svg';
import { ReactComponent as Amessage } from './icon-amessage.svg';
import { ReactComponent as Archive } from './icon-archive.svg';
import { ReactComponent as ArrowDown } from './icon-arrowDown.svg';
import { ReactComponent as ArrowUp } from './icon-arrowUp.svg';
import { ReactComponent as Assetplus } from './icon-assetplus.svg';
import { ReactComponent as AttachFile } from './icon-attach-file.svg';
import { ReactComponent as Attachment } from './icon-attachment.svg';
import { ReactComponent as Bank } from './icon-bank.svg';
import { ReactComponent as BarChart01 } from './icon-barChart01.svg';
import { ReactComponent as BarChart02 } from './icon-barChart02.svg';
import { ReactComponent as Bold } from './icon-bold.svg';
import { ReactComponent as Bond } from './icon-bond.svg';
import { ReactComponent as Book } from './icon-book.svg';
import { ReactComponent as Bookmark } from './icon-bookmark.svg';
import { ReactComponent as Briefcase } from './icon-briefcase.svg';
import { ReactComponent as Bulb } from './icon-bulb.svg';
import { ReactComponent as Calculator } from './icon-calculator.svg';
import { ReactComponent as Calendar } from './icon-calendar.svg';
import { ReactComponent as Camera } from './icon-camera.svg';
import { ReactComponent as CartFilled } from './icon-cart-filled.svg';
import { ReactComponent as CartOutline } from './icon-cart-outline.svg';
import { ReactComponent as Celebrate } from './icon-celebrate.svg';
import { ReactComponent as Chat } from './icon-chat.svg';
import { ReactComponent as CheckCircle } from './icon-check-circle.svg';
import { ReactComponent as CheckIntense } from './icon-check-intense.svg';
import { ReactComponent as Check } from './icon-check.svg';
import { ReactComponent as CheckOutline } from './icon-checkOutline.svg';
import { ReactComponent as Checklist } from './icon-checklist.svg';
import { ReactComponent as ChevronUpDouble } from './icon-chevron-up-double.svg';
import { ReactComponent as CircleOutline } from './icon-circleOutline.svg';
import { ReactComponent as ClappingFilled } from './icon-clapping-filled.svg';
import { ReactComponent as Clapping } from './icon-clapping.svg';
import { ReactComponent as Clock } from './icon-clock.svg';
import { ReactComponent as Close } from './icon-close.svg';
import { ReactComponent as CloseOutline } from './icon-closeOutline.svg';
import { ReactComponent as CoinsStacked } from './icon-coins-stacked.svg';
import { ReactComponent as ConsultFilled } from './icon-consult-filled.svg';
import { ReactComponent as ConsultOutline } from './icon-consult-outline.svg';
import { ReactComponent as Copy } from './icon-copy.svg';
import { ReactComponent as CopyNew } from './icon-copy_new.svg';
import { ReactComponent as CopyRights } from './icon-copy_rights.svg';
import { ReactComponent as CreditCard } from './icon-credit-card.svg';
import { ReactComponent as CrossMark } from './icon-cross-mark.svg';
import { ReactComponent as Delete } from './icon-delete.svg';
import { ReactComponent as Document } from './icon-document.svg';
import { ReactComponent as DotPoints } from './icon-dot-points.svg';
import { ReactComponent as DoubleCheck } from './icon-double-check.svg';
import { ReactComponent as DownRound } from './icon-down-round.svg';
import { ReactComponent as Down } from './icon-down.svg';
import { ReactComponent as DownloadArrow } from './icon-download-arrow.svg';
import { ReactComponent as Download } from './icon-download.svg';
import { ReactComponent as Drag } from './icon-drag.svg';
import { ReactComponent as Edit } from './icon-edit.svg';
import { ReactComponent as ErrorOutline } from './icon-error-outline.svg';
import { ReactComponent as Error } from './icon-error.svg';
import { ReactComponent as Event } from './icon-event.svg';
import { ReactComponent as Excel } from './icon-excel.svg';
import { ReactComponent as ExchangeFunds } from './icon-exchange_funds.svg';
import { ReactComponent as EyeOff } from './icon-eye-off.svg';
import { ReactComponent as Eye } from './icon-eye.svg';
import { ReactComponent as Faq } from './icon-faq.svg';
import { ReactComponent as FavFilled } from './icon-fav-filled.svg';
import { ReactComponent as FavOutline } from './icon-fav-outline.svg';
import { ReactComponent as FileAttachment } from './icon-fileAttachment.svg';
import { ReactComponent as Filter } from './icon-filter.svg';
import { ReactComponent as Folder } from './icon-folder.svg';
import { ReactComponent as FundFinder } from './icon-fundFinder.svg';
import { ReactComponent as Generate } from './icon-generate.svg';
import { ReactComponent as Gift } from './icon-gift.svg';
import { ReactComponent as GraduationHat } from './icon-graduation-hat.svg';
import { ReactComponent as Grid } from './icon-grid.svg';
import { ReactComponent as HandCoin } from './icon-handCoin.svg';
import { ReactComponent as HeartOutline } from './icon-heartOutline.svg';
import { ReactComponent as History } from './icon-history.svg';
import { ReactComponent as HomeFilled } from './icon-home-filled.svg';
import { ReactComponent as HomeOutline } from './icon-home-outline.svg';
import { ReactComponent as HorizontalMore } from './icon-horizontalMore.svg';
import { ReactComponent as Hourglass } from './icon-hourglass.svg';
import { ReactComponent as Image } from './icon-image.svg';
import { ReactComponent as Inbox } from './icon-inbox.svg';
import { ReactComponent as Income } from './icon-income.svg';
import { ReactComponent as Indicator } from './icon-indicator.svg';
import { ReactComponent as InfoIntense } from './icon-info-intense.svg';
import { ReactComponent as InfoSubtle } from './icon-info-subtle.svg';
import { ReactComponent as Info } from './icon-info.svg';
import { ReactComponent as InsuranceFilled } from './icon-insurance-filled.svg';
import { ReactComponent as InsuranceOutline } from './icon-insurance-outline.svg';
import { ReactComponent as InvestFilled } from './icon-invest-filled.svg';
import { ReactComponent as InvestOutline } from './icon-invest-outline.svg';
import { ReactComponent as Italic } from './icon-italic.svg';
import { ReactComponent as JusticeScale } from './icon-justiceScale.svg';
import { ReactComponent as Language } from './icon-language.svg';
import { ReactComponent as Language02 } from './icon-language02.svg';
import { ReactComponent as Language1 } from './icon-language1.svg';
import { ReactComponent as Layers } from './icon-layers.svg';
import { ReactComponent as LeftArrow } from './icon-left-arrow.svg';
import { ReactComponent as Left } from './icon-left.svg';
import { ReactComponent as LikeFilled } from './icon-like-filled.svg';
import { ReactComponent as LineChart } from './icon-lineChart.svg';
import { ReactComponent as Link } from './icon-link.svg';
import { ReactComponent as List } from './icon-list.svg';
import { ReactComponent as Loader } from './icon-loader.svg';
import { ReactComponent as Loading } from './icon-loading.svg';
import { ReactComponent as Location } from './icon-location.svg';
import { ReactComponent as Lock } from './icon-lock.svg';
import { ReactComponent as LogOut } from './icon-logOut.svg';
import { ReactComponent as Loss } from './icon-loss.svg';
import { ReactComponent as Mail } from './icon-mail.svg';
import { ReactComponent as Marketing } from './icon-marketing.svg';
import { ReactComponent as Media2 } from './icon-media2.svg';
import { ReactComponent as MedicalCross } from './icon-medical-cross.svg';
import { ReactComponent as Message } from './icon-message.svg';
import { ReactComponent as Navigation } from './icon-navigation.svg';
import { ReactComponent as NegativeIntense } from './icon-negative-intense.svg';
import { ReactComponent as NegativeSubtle } from './icon-negative-subtle.svg';
import { ReactComponent as NoteTrash } from './icon-note-trash.svg';
import { ReactComponent as NotificationFilled } from './icon-notification-filled.svg';
import { ReactComponent as NotificationOutline } from './icon-notification-outline.svg';
import { ReactComponent as NotificationActiveFilled } from './icon-notificationActive-filled.svg';
import { ReactComponent as NotificationActiveOutline } from './icon-notificationActive-outline.svg';
import { ReactComponent as Passcode } from './icon-passcode.svg';
import { ReactComponent as Pdf } from './icon-pdf.svg';
import { ReactComponent as PencilFilled } from './icon-pencil-filled.svg';
import { ReactComponent as PencilOutline } from './icon-pencil-outline.svg';
import { ReactComponent as Phone } from './icon-phone.svg';
import { ReactComponent as Pin } from './icon-pin.svg';
import { ReactComponent as Play } from './icon-play.svg';
import { ReactComponent as Plus } from './icon-plus.svg';
import { ReactComponent as PlusCircle } from './icon-plusCircle.svg';
import { ReactComponent as PlusRounded } from './icon-plusRounded.svg';
import { ReactComponent as Podcast } from './icon-podcast.svg';
import { ReactComponent as Poster } from './icon-poster.svg';
import { ReactComponent as Ppt } from './icon-ppt.svg';
import { ReactComponent as ProfileDocument } from './icon-profile-document.svg';
import { ReactComponent as Profile } from './icon-profile.svg';
import { ReactComponent as Profit } from './icon-profit.svg';
import { ReactComponent as RadioOn } from './icon-radio-on.svg';
import { ReactComponent as RefreshDouble } from './icon-refresh-double.svg';
import { ReactComponent as Refresh } from './icon-refresh.svg';
import { ReactComponent as Report } from './icon-report.svg';
import { ReactComponent as Retirement } from './icon-retirement.svg';
import { ReactComponent as Right } from './icon-right.svg';
import { ReactComponent as RocketFilled } from './icon-rocket-filled.svg';
import { ReactComponent as RocketOutline } from './icon-rocket-outline.svg';
import { ReactComponent as Rupee } from './icon-rupee.svg';
import { ReactComponent as Save } from './icon-save.svg';
import { ReactComponent as Scales } from './icon-scales.svg';
import { ReactComponent as SearchRefraction } from './icon-search-refraction.svg';
import { ReactComponent as Search } from './icon-search.svg';
import { ReactComponent as Send } from './icon-send.svg';
import { ReactComponent as SettingsFilled } from './icon-settings-filled.svg';
import { ReactComponent as SettingsOutline } from './icon-settings-outline.svg';
import { ReactComponent as ShareTool } from './icon-share-tool.svg';
import { ReactComponent as Share } from './icon-share.svg';
import { ReactComponent as Share02 } from './icon-share02.svg';
import { ReactComponent as Shield } from './icon-shield.svg';
import { ReactComponent as Shop } from './icon-shop.svg';
import { ReactComponent as Sort } from './icon-sort.svg';
import { ReactComponent as Sparkles } from './icon-sparkles.svg';
import { ReactComponent as StarFilled } from './icon-star-filled.svg';
import { ReactComponent as StarOutline } from './icon-star-outline.svg';
import { ReactComponent as StrikeThrough } from './icon-strike-through.svg';
import { ReactComponent as SuperStarter } from './icon-super_starter.svg';
import { ReactComponent as Support } from './icon-support.svg';
import { ReactComponent as Switch } from './icon-switch.svg';
import { ReactComponent as Team } from './icon-team.svg';
import { ReactComponent as TickRound } from './icon-tick-round.svg';
import { ReactComponent as Tool01 } from './icon-tool-01.svg';
import { ReactComponent as Tool } from './icon-tool.svg';
import { ReactComponent as Trash } from './icon-trash.svg';
import { ReactComponent as Truck } from './icon-truck.svg';
import { ReactComponent as Umbrella } from './icon-umbrella.svg';
import { ReactComponent as Underline } from './icon-underline.svg';
import { ReactComponent as Unlock } from './icon-unlock.svg';
import { ReactComponent as UpRound } from './icon-up-round.svg';
import { ReactComponent as Up } from './icon-up.svg';
import { ReactComponent as Upload } from './icon-upload.svg';
import { ReactComponent as UserFilled } from './icon-user-filled.svg';
import { ReactComponent as UserOutline } from './icon-user-outline.svg';
import { ReactComponent as UserPlus } from './icon-user-plus.svg';
import { ReactComponent as UsersFilled } from './icon-users-filled.svg';
import { ReactComponent as UsersOutline } from './icon-users-outline.svg';
import { ReactComponent as Vault } from './icon-vault.svg';
import { ReactComponent as VerticalMore } from './icon-verticalMore.svg';
import { ReactComponent as Video } from './icon-video.svg';
import { ReactComponent as View } from './icon-view.svg';
import { ReactComponent as Wand } from './icon-wand.svg';
import { ReactComponent as WaringSubtle } from './icon-waring-subtle.svg';
import { ReactComponent as WarningIntense } from './icon-warning-intense.svg';
import { ReactComponent as Warning } from './icon-warning.svg';
import { ReactComponent as Webinar } from './icon-webinar.svg';
import { ReactComponent as Whatsapp } from './icon-whatsapp.svg';
import { ReactComponent as InboxSolid } from './inbox_solid.svg';
import { ReactComponent as InfoCircle } from './info-circle.svg';
import { ReactComponent as InfoSquareSolid } from './info-square_solid.svg';
import { ReactComponent as LayersThreeSolid } from './layers-three_solid.svg';
import { ReactComponent as LightbulbSolid } from './lightbulb_solid.svg';
import { ReactComponent as LockUnlockedSolid } from './lock-unlocked_solid.svg';
import { ReactComponent as LockSolid } from './lock_solid.svg';
import { ReactComponent as LogInLine } from './log-in_line.svg';
import { ReactComponent as MailSolid } from './mail_solid.svg';
import { ReactComponent as MarkerPinSolid } from './marker-pin_solid.svg';
import { ReactComponent as MenuLine } from './menu_line.svg';
import { ReactComponent as MessageChatSquareSolid } from './message-chat-square_solid.svg';
import { ReactComponent as MessageQuestionSquareSolid } from './message-question-square_solid.svg';
import { ReactComponent as MobilePhoneLine } from './mobile-phone_line.svg';
import { ReactComponent as MobilePhoneSolid } from './mobile-phone_solid.svg';
import { ReactComponent as MoonLine } from './moon_line.svg';
import { ReactComponent as MoonSolid } from './moon_solid.svg';
import { ReactComponent as PasscodeSolid } from './passcode_solid.svg';
import { ReactComponent as PauseSquareLine } from './pause-square_line.svg';
import { ReactComponent as PauseSquareSolid } from './pause-square_solid.svg';
import { ReactComponent as PhoneSolid } from './phone_solid.svg';
import { ReactComponent as PinSolid } from './pin_solid.svg';
import { ReactComponent as PlayLine } from './play_line.svg';
import { ReactComponent as PosterSolid } from './poster_solid.svg';
import { ReactComponent as RefreshCw01Line } from './refresh-cw-01_line.svg';
import { ReactComponent as SaveSolid } from './save_solid.svg';
import { ReactComponent as ScalesSolid } from './scales_solid.svg';
import { ReactComponent as SendSolid } from './send_solid.svg';
import { ReactComponent as Share02Solid } from './share-02_solid.svg';
import { ReactComponent as ShieldSolid } from './shield_solid.svg';
import { ReactComponent as SignalLine } from './signal_line.svg';
import { ReactComponent as SignalSolid } from './signal_solid.svg';
import { ReactComponent as SwitchHorizontal01Line } from './switch-horizontal-01_line.svg';
import { ReactComponent as SwitchVertical01Line } from './switch-vertical-01_line.svg';
import { ReactComponent as TargetSolid } from './target_solid.svg';
import { ReactComponent as Tool01Solid } from './tool-01_solid.svg';
import { ReactComponent as Tool02Solid } from './tool-02_solid.svg';
import { ReactComponent as TrashSolid } from './trash_solid.svg';
import { ReactComponent as TvSolid } from './tv_solid.svg';
import { ReactComponent as UmbrellaSolid } from './umbrella_solid.svg';
import { ReactComponent as VideoRecorderSolid } from './video-recorder_solid.svg';
import { ReactComponent as WhatsappSolid } from './whatsapp_solid.svg';

/**
 * @deprecated use APIcon instead with icon="activityLine"
 */
export function ActivityLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ActivityLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="alertTriangleSolid"
 */
export function AlertTriangleSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <AlertTriangleSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="anchorLine"
 */
export function AnchorLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <AnchorLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="announcementSolid"
 */
export function AnnouncementSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <AnnouncementSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="archiveSolid"
 */
export function ArchiveSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArchiveSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenDownLine"
 */
export function ArrowCircleBrokenDownLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenDownLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenDownSolid"
 */
export function ArrowCircleBrokenDownSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenDownSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenLeftLine"
 */
export function ArrowCircleBrokenLeftLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenLeftLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenLeftSolid"
 */
export function ArrowCircleBrokenLeftSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenLeftSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenRightLine"
 */
export function ArrowCircleBrokenRightLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenRightLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenRightSolid"
 */
export function ArrowCircleBrokenRightSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenRightSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenUpLeftLine"
 */
export function ArrowCircleBrokenUpLeftLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenUpLeftLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenUpLeftSolid"
 */
export function ArrowCircleBrokenUpLeftSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenUpLeftSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenUpRightLine"
 */
export function ArrowCircleBrokenUpRightLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenUpRightLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenUpRightSolid"
 */
export function ArrowCircleBrokenUpRightSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenUpRightSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenUpLine"
 */
export function ArrowCircleBrokenUpLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenUpLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleBrokenUpSolid"
 */
export function ArrowCircleBrokenUpSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleBrokenUpSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleDownLeftLine"
 */
export function ArrowCircleDownLeftLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleDownLeftLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleDownLeftSolid"
 */
export function ArrowCircleDownLeftSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleDownLeftSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleDownRightLine"
 */
export function ArrowCircleDownRightLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleDownRightLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleDownRightSolid"
 */
export function ArrowCircleDownRightSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleDownRightSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleDownLine"
 */
export function ArrowCircleDownLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleDownLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleLeftLine"
 */
export function ArrowCircleLeftLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleLeftLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleLeftSolid"
 */
export function ArrowCircleLeftSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleLeftSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleRightLine"
 */
export function ArrowCircleRightLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleRightLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleRightSolid"
 */
export function ArrowCircleRightSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleRightSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowCircleUpLine"
 */
export function ArrowCircleUpLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowCircleUpLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowNarrowDownLeftLine"
 */
export function ArrowNarrowDownLeftLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowNarrowDownLeftLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowNarrowDownRightLine"
 */
export function ArrowNarrowDownRightLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowNarrowDownRightLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowNarrowRightLine"
 */
export function ArrowNarrowRightLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowNarrowRightLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowNarrowUpLeftLine"
 */
export function ArrowNarrowUpLeftLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowNarrowUpLeftLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowNarrowUpRightLine"
 */
export function ArrowNarrowUpRightLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowNarrowUpRightLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowSquareDownLine"
 */
export function ArrowSquareDownLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowSquareDownLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowSquareDownSolid"
 */
export function ArrowSquareDownSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowSquareDownSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowSquareLeftLine"
 */
export function ArrowSquareLeftLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowSquareLeftLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowSquareLeftSolid"
 */
export function ArrowSquareLeftSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowSquareLeftSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowSquareRightLine"
 */
export function ArrowSquareRightLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowSquareRightLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowSquareRightSolid"
 */
export function ArrowSquareRightSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowSquareRightSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowSquareUpLine"
 */
export function ArrowSquareUpLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowSquareUpLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowSquareUpSolid"
 */
export function ArrowSquareUpSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowSquareUpSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="asterisk01Line"
 */
export function Asterisk01LineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Asterisk01Line height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="asterisk02Line"
 */
export function Asterisk02LineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Asterisk02Line height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="atSignLine"
 */
export function AtSignLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <AtSignLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bankSolid"
 */
export function BankSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BankSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="barChartSolid"
 */
export function BarChartSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BarChartSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookClosedSolid"
 */
export function BookClosedSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookClosedSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkAddLine"
 */
export function BookmarkAddLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkAddLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkAddSolid"
 */
export function BookmarkAddSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkAddSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkCheckLine"
 */
export function BookmarkCheckLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkCheckLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkCheckSolid"
 */
export function BookmarkCheckSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkCheckSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkMinusLine"
 */
export function BookmarkMinusLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkMinusLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkMinusSolid"
 */
export function BookmarkMinusSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkMinusSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkXLine"
 */
export function BookmarkXLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkXLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkXSolid"
 */
export function BookmarkXSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkXSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmarkSolid"
 */
export function BookmarkSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BookmarkSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="briefcaseSolid"
 */
export function BriefcaseSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BriefcaseSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="building01Line"
 */
export function Building01LineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Building01Line height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="building01Solid"
 */
export function Building01SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Building01Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="building02Line"
 */
export function Building02LineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Building02Line height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="building02Solid"
 */
export function Building02SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Building02Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="calculatorSolid"
 */
export function CalculatorSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CalculatorSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="calendarDateSolid"
 */
export function CalendarDateSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CalendarDateSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="cameraSolid"
 */
export function CameraSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CameraSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="chatCircleSolid"
 */
export function ChatCircleSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ChatCircleSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="chevronSelectorVertical"
 */
export function ChevronSelectorVerticalIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ChevronSelectorVertical height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="circleChevronDownSolid"
 */
export function CircleChevronDownSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CircleChevronDownSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="circleChevronLeftSolid"
 */
export function CircleChevronLeftSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CircleChevronLeftSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="circleChevronRightSolid"
 */
export function CircleChevronRightSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CircleChevronRightSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="circleChevronUpSolid"
 */
export function CircleChevronUpSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CircleChevronUpSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="circleSwitchHorizontal01Solid"
 */
export function CircleSwitchHorizontal01SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CircleSwitchHorizontal01Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="circleSwitchHorizontal02Solid"
 */
export function CircleSwitchHorizontal02SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CircleSwitchHorizontal02Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="circleSwitchVertical02Solid"
 */
export function CircleSwitchVertical02SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CircleSwitchVertical02Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="clockSolid"
 */
export function ClockSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ClockSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="coinsHandSolid"
 */
export function CoinsHandSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CoinsHandSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="coinsStackedSolid"
 */
export function CoinsStackedSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CoinsStackedSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="copySolid"
 */
export function CopySolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CopySolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="deleteSolid"
 */
export function DeleteSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <DeleteSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="edit01Solid"
 */
export function Edit01SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Edit01Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="eyeOffSolid"
 */
export function EyeOffSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <EyeOffSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="eyeSolid"
 */
export function EyeSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <EyeSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="fileAttachmentSolid"
 */
export function FileAttachmentSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FileAttachmentSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="fileChartSolid"
 */
export function FileChartSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FileChartSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="fileDownloadSolid"
 */
export function FileDownloadSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FileDownloadSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="fileSolid"
 */
export function FileSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FileSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="folderSolid"
 */
export function FolderSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FolderSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="giftSolid"
 */
export function GiftSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <GiftSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="graduationHatSolid"
 */
export function GraduationHatSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <GraduationHatSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="gridSolid"
 */
export function GridSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <GridSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="helpCircleLine"
 */
export function HelpCircleLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <HelpCircleLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="hourglassSolid"
 */
export function HourglassSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <HourglassSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="advisorFilled"
 */
export function AdvisorFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <AdvisorFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="advisorOutline"
 */
export function AdvisorOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <AdvisorOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="alertOctagon"
 */
export function AlertOctagonIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <AlertOctagon height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="amessage"
 */
export function AmessageIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Amessage height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="archive"
 */
export function ArchiveIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Archive height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowDown"
 */
export function ArrowDownIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowDown height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="arrowUp"
 */
export function ArrowUpIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ArrowUp height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="assetplus"
 */
export function AssetplusIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Assetplus height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="attachFile"
 */
export function AttachFileIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <AttachFile height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="attachment"
 */
export function AttachmentIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Attachment height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bank"
 */
export function BankIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Bank height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="barChart01"
 */
export function BarChart01Icon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BarChart01 height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="barChart02"
 */
export function BarChart02Icon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <BarChart02 height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bold"
 */
export function BoldIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Bold height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bond"
 */
export function BondIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Bond height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="book"
 */
export function BookIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Book height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bookmark"
 */
export function BookmarkIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Bookmark height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="briefcase"
 */
export function BriefcaseIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Briefcase height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="bulb"
 */
export function BulbIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Bulb height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="calculator"
 */
export function CalculatorIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Calculator height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="calendar"
 */
export function CalendarIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Calendar height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="camera"
 */
export function CameraIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Camera height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="cartFilled"
 */
export function CartFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CartFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="cartOutline"
 */
export function CartOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CartOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="celebrate"
 */
export function CelebrateIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Celebrate height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="chat"
 */
export function ChatIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Chat height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="checkCircle"
 */
export function CheckCircleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CheckCircle height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="checkIntense"
 */
export function CheckIntenseIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CheckIntense height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="check"
 */
export function CheckIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Check height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="checkOutline"
 */
export function CheckOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CheckOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="checklist"
 */
export function ChecklistIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Checklist height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="chevronUpDouble"
 */
export function ChevronUpDoubleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ChevronUpDouble height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="circleOutline"
 */
export function CircleOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CircleOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="clappingFilled"
 */
export function ClappingFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ClappingFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="clapping"
 */
export function ClappingIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Clapping height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="clock"
 */
export function ClockIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Clock height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="close"
 */
export function CloseIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Close height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="closeOutline"
 */
export function CloseOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CloseOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="coinsStacked"
 */
export function CoinsStackedIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CoinsStacked height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="consultFilled"
 */
export function ConsultFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ConsultFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="consultOutline"
 */
export function ConsultOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ConsultOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="copy"
 */
export function CopyIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Copy height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="copyNew"
 */
export function CopyNewIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CopyNew height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="copyRights"
 */
export function CopyRightsIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CopyRights height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="creditCard"
 */
export function CreditCardIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CreditCard height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="crossMark"
 */
export function CrossMarkIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <CrossMark height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="delete"
 */
export function DeleteIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Delete height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="document"
 */
export function DocumentIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Document height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="dotPoints"
 */
export function DotPointsIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <DotPoints height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="doubleCheck"
 */
export function DoubleCheckIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <DoubleCheck height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="downRound"
 */
export function DownRoundIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <DownRound height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="down"
 */
export function DownIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Down height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="downloadArrow"
 */
export function DownloadArrowIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <DownloadArrow height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="download"
 */
export function DownloadIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Download height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="drag"
 */
export function DragIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Drag height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="edit"
 */
export function EditIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Edit height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="errorOutline"
 */
export function ErrorOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ErrorOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="error"
 */
export function ErrorIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Error height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="event"
 */
export function EventIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Event height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="excel"
 */
export function ExcelIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Excel height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="exchangeFunds"
 */
export function ExchangeFundsIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ExchangeFunds height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="eyeOff"
 */
export function EyeOffIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <EyeOff height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="eye"
 */
export function EyeIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Eye height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="faq"
 */
export function FaqIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Faq height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="favFilled"
 */
export function FavFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FavFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="favOutline"
 */
export function FavOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FavOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="fileAttachment"
 */
export function FileAttachmentIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FileAttachment height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="filter"
 */
export function FilterIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Filter height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="folder"
 */
export function FolderIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Folder height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="fundFinder"
 */
export function FundFinderIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <FundFinder height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="generate"
 */
export function GenerateIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Generate height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="gift"
 */
export function GiftIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Gift height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="graduationHat"
 */
export function GraduationHatIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <GraduationHat height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="grid"
 */
export function GridIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Grid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="handCoin"
 */
export function HandCoinIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <HandCoin height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="heartOutline"
 */
export function HeartOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <HeartOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="history"
 */
export function HistoryIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <History height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="homeFilled"
 */
export function HomeFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <HomeFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="homeOutline"
 */
export function HomeOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <HomeOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="horizontalMore"
 */
export function HorizontalMoreIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <HorizontalMore height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="hourglass"
 */
export function HourglassIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Hourglass height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="image"
 */
export function ImageIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Image height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="inbox"
 */
export function InboxIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Inbox height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="income"
 */
export function IncomeIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Income height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="indicator"
 */
export function IndicatorIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Indicator height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="infoIntense"
 */
export function InfoIntenseIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InfoIntense height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="infoSubtle"
 */
export function InfoSubtleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InfoSubtle height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="info"
 */
export function InfoIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Info height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="insuranceFilled"
 */
export function InsuranceFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InsuranceFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="insuranceOutline"
 */
export function InsuranceOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InsuranceOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="investFilled"
 */
export function InvestFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InvestFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="investOutline"
 */
export function InvestOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InvestOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="italic"
 */
export function ItalicIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Italic height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="justiceScale"
 */
export function JusticeScaleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <JusticeScale height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="language"
 */
export function LanguageIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Language height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="language02"
 */
export function Language02Icon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Language02 height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="language1"
 */
export function Language1Icon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Language1 height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="layers"
 */
export function LayersIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Layers height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="leftArrow"
 */
export function LeftArrowIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LeftArrow height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="left"
 */
export function LeftIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Left height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="likeFilled"
 */
export function LikeFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LikeFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="lineChart"
 */
export function LineChartIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LineChart height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="link"
 */
export function LinkIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Link height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="list"
 */
export function ListIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <List height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="loader"
 */
export function LoaderIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Loader height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="loading"
 */
export function LoadingIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Loading height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="location"
 */
export function LocationIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Location height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="lock"
 */
export function LockIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Lock height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="logOut"
 */
export function LogOutIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LogOut height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="loss"
 */
export function LossIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Loss height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="mail"
 */
export function MailIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Mail height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="marketing"
 */
export function MarketingIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Marketing height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="media2"
 */
export function Media2Icon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Media2 height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="medicalCross"
 */
export function MedicalCrossIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MedicalCross height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="message"
 */
export function MessageIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Message height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="navigation"
 */
export function NavigationIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Navigation height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="negativeIntense"
 */
export function NegativeIntenseIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <NegativeIntense height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="negativeSubtle"
 */
export function NegativeSubtleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <NegativeSubtle height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="noteTrash"
 */
export function NoteTrashIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <NoteTrash height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="notificationFilled"
 */
export function NotificationFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <NotificationFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="notificationOutline"
 */
export function NotificationOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <NotificationOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="notificationActiveFilled"
 */
export function NotificationActiveFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <NotificationActiveFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="notificationActiveOutline"
 */
export function NotificationActiveOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <NotificationActiveOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="passcode"
 */
export function PasscodeIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Passcode height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="pdf"
 */
export function PdfIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Pdf height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="pencilFilled"
 */
export function PencilFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PencilFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="pencilOutline"
 */
export function PencilOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PencilOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="phone"
 */
export function PhoneIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Phone height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="pin"
 */
export function PinIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Pin height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="play"
 */
export function PlayIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Play height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="plus"
 */
export function PlusIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Plus height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="plusCircle"
 */
export function PlusCircleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PlusCircle height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="plusRounded"
 */
export function PlusRoundedIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PlusRounded height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="podcast"
 */
export function PodcastIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Podcast height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="poster"
 */
export function PosterIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Poster height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="ppt"
 */
export function PptIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Ppt height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="profileDocument"
 */
export function ProfileDocumentIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ProfileDocument height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="profile"
 */
export function ProfileIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Profile height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="profit"
 */
export function ProfitIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Profit height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="radioOn"
 */
export function RadioOnIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <RadioOn height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="refreshDouble"
 */
export function RefreshDoubleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <RefreshDouble height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="refresh"
 */
export function RefreshIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Refresh height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="report"
 */
export function ReportIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Report height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="retirement"
 */
export function RetirementIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Retirement height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="right"
 */
export function RightIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Right height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="rocketFilled"
 */
export function RocketFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <RocketFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="rocketOutline"
 */
export function RocketOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <RocketOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="rupee"
 */
export function RupeeIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Rupee height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="save"
 */
export function SaveIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Save height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="scales"
 */
export function ScalesIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Scales height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="searchRefraction"
 */
export function SearchRefractionIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SearchRefraction height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="search"
 */
export function SearchIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Search height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="send"
 */
export function SendIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Send height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="settingsFilled"
 */
export function SettingsFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SettingsFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="settingsOutline"
 */
export function SettingsOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SettingsOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="shareTool"
 */
export function ShareToolIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ShareTool height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="share"
 */
export function ShareIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Share height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="share02"
 */
export function Share02Icon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Share02 height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="shield"
 */
export function ShieldIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Shield height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="shop"
 */
export function ShopIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Shop height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="sort"
 */
export function SortIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Sort height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="sparkles"
 */
export function SparklesIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Sparkles height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="starFilled"
 */
export function StarFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <StarFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="starOutline"
 */
export function StarOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <StarOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="strikeThrough"
 */
export function StrikeThroughIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <StrikeThrough height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="superStarter"
 */
export function SuperStarterIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SuperStarter height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="support"
 */
export function SupportIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Support height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="switch"
 */
export function SwitchIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Switch height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="team"
 */
export function TeamIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Team height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="tickRound"
 */
export function TickRoundIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <TickRound height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="tool01"
 */
export function Tool01Icon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Tool01 height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="tool"
 */
export function ToolIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Tool height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="trash"
 */
export function TrashIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Trash height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="truck"
 */
export function TruckIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Truck height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="umbrella"
 */
export function UmbrellaIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Umbrella height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="underline"
 */
export function UnderlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Underline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="unlock"
 */
export function UnlockIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Unlock height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="upRound"
 */
export function UpRoundIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <UpRound height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="up"
 */
export function UpIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Up height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="upload"
 */
export function UploadIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Upload height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="userFilled"
 */
export function UserFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <UserFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="userOutline"
 */
export function UserOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <UserOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="userPlus"
 */
export function UserPlusIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <UserPlus height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="usersFilled"
 */
export function UsersFilledIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <UsersFilled height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="usersOutline"
 */
export function UsersOutlineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <UsersOutline height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="vault"
 */
export function VaultIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Vault height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="verticalMore"
 */
export function VerticalMoreIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <VerticalMore height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="video"
 */
export function VideoIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Video height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="view"
 */
export function ViewIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <View height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="wand"
 */
export function WandIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Wand height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="waringSubtle"
 */
export function WaringSubtleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <WaringSubtle height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="warningIntense"
 */
export function WarningIntenseIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <WarningIntense height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="warning"
 */
export function WarningIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Warning height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="webinar"
 */
export function WebinarIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Webinar height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="whatsapp"
 */
export function WhatsappIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Whatsapp height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="inboxSolid"
 */
export function InboxSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InboxSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="infoCircle"
 */
export function InfoCircleIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InfoCircle height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="infoSquareSolid"
 */
export function InfoSquareSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InfoSquareSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="layersThreeSolid"
 */
export function LayersThreeSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LayersThreeSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="lightbulbSolid"
 */
export function LightbulbSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LightbulbSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="lockUnlockedSolid"
 */
export function LockUnlockedSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LockUnlockedSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="lockSolid"
 */
export function LockSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LockSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="logInLine"
 */
export function LogInLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <LogInLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="mailSolid"
 */
export function MailSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MailSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="markerPinSolid"
 */
export function MarkerPinSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MarkerPinSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="menuLine"
 */
export function MenuLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MenuLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="messageChatSquareSolid"
 */
export function MessageChatSquareSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MessageChatSquareSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="messageQuestionSquareSolid"
 */
export function MessageQuestionSquareSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MessageQuestionSquareSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="mobilePhoneLine"
 */
export function MobilePhoneLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MobilePhoneLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="mobilePhoneSolid"
 */
export function MobilePhoneSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MobilePhoneSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="moonLine"
 */
export function MoonLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MoonLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="moonSolid"
 */
export function MoonSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <MoonSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="passcodeSolid"
 */
export function PasscodeSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PasscodeSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="pauseSquareLine"
 */
export function PauseSquareLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PauseSquareLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="pauseSquareSolid"
 */
export function PauseSquareSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PauseSquareSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="phoneSolid"
 */
export function PhoneSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PhoneSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="pinSolid"
 */
export function PinSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PinSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="playLine"
 */
export function PlayLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PlayLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="posterSolid"
 */
export function PosterSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <PosterSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="refreshCw01Line"
 */
export function RefreshCw01LineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <RefreshCw01Line height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="saveSolid"
 */
export function SaveSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SaveSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="scalesSolid"
 */
export function ScalesSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ScalesSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="sendSolid"
 */
export function SendSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SendSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="share02Solid"
 */
export function Share02SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Share02Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="shieldSolid"
 */
export function ShieldSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <ShieldSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="signalLine"
 */
export function SignalLineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SignalLine height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="signalSolid"
 */
export function SignalSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SignalSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="switchHorizontal01Line"
 */
export function SwitchHorizontal01LineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SwitchHorizontal01Line height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="switchVertical01Line"
 */
export function SwitchVertical01LineIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SwitchVertical01Line height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="targetSolid"
 */
export function TargetSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <TargetSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="tool01Solid"
 */
export function Tool01SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Tool01Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="tool02Solid"
 */
export function Tool02SolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <Tool02Solid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="trashSolid"
 */
export function TrashSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <TrashSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="tvSolid"
 */
export function TvSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <TvSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="umbrellaSolid"
 */
export function UmbrellaSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <UmbrellaSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="videoRecorderSolid"
 */
export function VideoRecorderSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <VideoRecorderSolid height={size + "px"} width={size + "px"} color={color} />
}

/**
 * @deprecated use APIcon instead with icon="whatsappSolid"
 */
export function WhatsappSolidIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <WhatsappSolid height={size + "px"} width={size + "px"} color={color} />
}

export function InflationGraphIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InflationGraph height={size + "px"} width={size + "px"} color={color} />
}

export function InsurancePersonIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <InsurancePerson height={size + "px"} width={size + "px"} color={color} />
}

export function SendMessageIcon({ size = 24, color = "#232730" }: { size?: number, color?: string }) {
    return <SendMessage height={size + "px"} width={size + "px"} color={color} />
}
